module.exports = __webpack_public_path__ + "static/media/aditivo.c87e83e3.pdf";